export default {
  wrongAddressFormat: 'Falsches Adressformat',
  disconnectWallet: 'App trennen',
  memo: 'Notiz',
  stage: 'Stufe',
  tokenomics: 'App-Übersicht',
  tokensPurchased: 'Ausgewählte Elemente',
  youShouldAgree: 'Sie müssen den Geschäftsbedingungen zustimmen',
  requiredField: 'Pflichtfeld',
  minValueIs: 'Mindestwert ist',
  maxValueIs: 'Höchstwert ist',
  cannotCopyToClipboard: 'Kann nicht in die Zwischenablage kopieren',
  copiedToClipboard: 'In die Zwischenablage kopiert',
  failed: 'Aktion fehlgeschlagen',
  success: 'Aktion war erfolgreich',
  aboutUs: 'Über uns',
  bonuses: 'Boni',
  whitepaper: 'Leitfaden',
  team: 'Team',
  community: 'Community',
  checkAddress: 'Adresse prüfen',
  theUltimateDollum: 'Ultimative DOLLUM-App für sicheren Zugang',
  unlockTheFuture:
    'Entsperren Sie die Zukunft mit der DOLLUM-App. Sicher, schnell und bereit für alle Ihre digitalen Bedürfnisse.',
  currentPrice: 'AKTUELLER PLAN',
  bonusToBase: 'BONUS ZUM BASISPLAN',
  raised: 'gesammelt',
  listingPrice: 'LISTENPREIS',
  scrollDownTo: 'Scrollen Sie nach unten, um mehr zu erfahren',
  keyFeaturesOf: 'Hauptfunktionen der DOLLUM-App',
  essentialDollumFeatures:
    'Wesentliche DOLLUM-App-Funktionen für Ihre Sicherheit und Bequemlichkeit.',
  commissionOptimizer: 'Leistungsoptimierer',
  reduceTransactionCosts:
    'Reduzieren Sie Ressourcenkosten, indem Sie automatisch die effizienteste Option wählen.',
  emergencyStopMode: 'Notstopp-Modus',
  instantlyProtectAssets:
    'Schützen Sie Ihr Konto sofort mit einer einzigen Aktion in Notfällen.',
  antiHijackFeature: 'Anti-Entführungsfunktion',
  lockYourWallet:
    'Sperren Sie Ihre App unter Bedrohung durch Aktivierung eines versteckten Notfallsignals.',
  cryptoInvestmentPortfolio: 'Personalisierte Übersicht',
  manageYourCrypto:
    'Verwalten Sie Ihre Inhalte mit vorgefertigten Layouts mit einem Klick.',
  backupAddress: 'Sicherungsadresse',
  redirectAssetsTo:
    'Leiten Sie Daten nach längerer Inaktivität an eine Sicherungsadresse weiter.',
  bonusStages: 'BONUSPHASEN',
  over320Million:
    'Über 320 Millionen Menschen nutzen weltweit digitale Apps, was eine wachsende Nachfrage nach sicheren Lösungen schafft.',
  tokenStructure: 'APP-STRUKTUR',
  onlyEmtVill: 'NUR 210.000.000 EINHEITEN WERDEN VORVERKAUFT!',
  remainingTokens: 'Zugewiesene Einheiten',
  totalRaised: 'Insgesamt zugewiesen',
  other: 'Andere',
  is: 'ist',
  connectWallet: 'App verbinden',
  operationInProgress: 'Vorgang läuft',
  pleaseWait: 'Bitte warten',
  buying: 'Verarbeitung',
  for: 'für',
  confirmThisTransaction: 'Bestätigen Sie diese Aktion in Ihrer App',
  changeMetamaskWallet: 'Verbinden Sie eine andere App',
  connectedWith: 'Verbunden mit',
  copyAddress: 'Adresse kopieren',
  viewOnExplorer: 'Im Explorer ansehen',
  checkAddressText:
    'Sie können die Adresse eingeben, die Sie bei der Registrierung in unserer App verwendet haben, um den Status anzuzeigen.',
  frozenFor: 'Eingefroren für ',
  month: 'Monat',
  months: 'Monate',
  scheduleOfThe: 'Zeitplan der Freischaltungssequenz',
  back: 'ZURÜCK',
  available: 'Verfügbar',
  buy: 'Auswählen',
  enterTheWallet:
    'Geben Sie die Adresse ein, an die Sie die Aktivierung erhalten möchten.',
  addressMustBe:
    'Die eingegebene Adresse muss mit dem richtigen Netzwerk übereinstimmen. Andernfalls geht die Anfrage verloren.',
  youAreAt: 'Sie sind bei Schritt',
  of: 'von',
  notUseExchangeWallets:
    'Verwenden Sie keine Börsenkonten, nur unterstützte Apps (z. B. Metamask, Trust App, Coinbase App)',
  continue: 'Weiter',
  youAreOnLast: 'Sie sind im letzten Schritt',
  youMustTransfer: 'Sie müssen Daten in Höhe von senden',
  address: 'Adresse',
  thisOperationTakes: 'Der Vorgang dauert bis zu 3 Stunden',
  update: 'Aktualisieren',
  copyTransactionHash: 'Vorgangs-ID kopieren',
  copy: 'Kopieren',
  depositTheSpecified: 'Senden Sie die angegebenen Daten an diese App',
  balance: 'Kontostand',
  receive: 'Empfangen',
  theOperationSuccessful: 'Der Vorgang war erfolgreich',
  yourFundsWill: 'Ihre Daten werden an Ihre App geliefert',
  afterTheCompletion:
    'Nach Abschluss aller Phasen beginnt der Freischaltungsprozess',
  theAmountOf: 'Der Betrag von',
  setOneText1: '1,5 Milliarden USD App-Marktwert im Jahr 2023',
  setOneText2: '40% des Markterlöses durch digitale Plattformen',
  setOneText3: '50% Wachstum bei digitalen Transfers im nächsten Jahrzehnt',
  setTwoText1: '70% der Nutzer bevorzugen integrierte Funktionen',
  setTwoText2: '175 Millionen USD potenzieller Umsatz aus Serviceverkäufen',
  setTwoText3: '10% des Gesamtangebots für Wachstumsinitiativen reserviert',
  metric: 'Kennzahl',
  currentMarketState: 'Aktueller Marktstatus',
  forecastedGrowth: 'Prognostiziertes Wachstum',
  userSegments: 'Nutzersegmente',
  opportunitiesForDollum: 'Chancen für die DOLLUM-App',
  marketValue: 'Marktwert',
  retailInvestorsFinancial: 'Allgemeine Nutzer, Institutionen',
  increasingDemandFor: 'Steigende Nachfrage nach sicheren Apps',
  numberOfCrypto: 'Anzahl der digitalen Nutzer',
  expectedToReach: 'Bis 2030 voraussichtlich über 500 Millionen',
  youthEntrepreneursInstitutional:
    'Jugendliche, Unternehmer, institutionelle Kunden',
  attractNewUsers: 'Neue Nutzer durch Innovation gewinnen',
  mobileWalletShare: 'Marktanteil mobiler Apps',
  belongsToAndroid: '45% des Marktes gehören Android',
  mobileSolutionsExpected: 'Mobile Lösungen sollen jährlich um 10% wachsen',
  smartphoneUsers: 'Smartphone-Nutzer',
  convenienceAndMobile: 'Bequemlichkeit und mobiler Zugang',
  defiAndStacking: 'Erweiterte Funktionen',
  integrationWithDefi: 'Integration mit Drittanbieterprotokollen',
  exponentialGrowthIn: 'Exponentielles Wachstum der Nachfrage nach Services',
  activeCryptoInvestors: 'Aktive digitale Nutzer',
  directAccessTo: 'Direkter Zugang zu erweiterten Tools',
  marketRegions: 'Marktregionen',
  marketLeaders: 'Marktführer: Nordamerika, Asien',
  asiaAndLatin: 'Asien und Lateinamerika – vielversprechendste Regionen',
  entrepreneursAndLow: 'Unternehmer und neue Nutzer',
  expansionIntoNew: 'Expansion in neue Märkte',
  millionCryptoUsers: 'Millionen App-Nutzer weltweit',
  allocationOfFunds: 'RESSOURCENZUWEISUNG',
  seedRound: 'Frühphasen',
  round: 'Runde',
  Round: 'Runde',
  tokenPrice: 'Wert pro Element',
  privateRound: 'Interne Phase',
  presaleRound: 'Vorläufige Phase',
  publicSaleRound: 'Öffentliche Runde',
  marketingCommunityBuilding: 'Marketing, Community-Aufbau, Airdrop',
  teamAndFounders: 'Team und Gründer',
  ecosystemDevelopmentFund: 'Fonds zur Ökosystementwicklung',
  liquidityFund: 'Ressourcenfonds',
  stakingRewards: 'Engagement-Belohnungen',
  reserveFund: 'Reservefonds',
  usersChooseStaking: '70% der Nutzer wählen Engagement-Funktionen in DOLLUM',
  theMajorityOf:
    'Die Mehrheit der DOLLUM-App-Nutzer beteiligt sich aktiv, um stabile Vorteile zu erzielen und am Wachstum des Ökosystems teilzunehmen – dank hoher Leistung und Sicherheit der App.',
  preliminaryEstimateBased:
    '**Dies ist eine vorläufige Schätzung basierend auf aktuellen Markttrends.',
  roadmapText1: 'Nicht verwahrende App',
  roadmapText1Part2: 'Kernfunktionen',
  roadmapText1Part3: 'Leitfaden',
  roadmapText2: 'Nicht verwahrende App',
  roadmapText2Part2: 'Kernfunktionen',
  roadmapText2Part3: 'Leitfaden',
  roadmapText3: 'Anti-Entführung',
  roadmapText3Part2: 'App-Start',
  roadmapText3Part3: 'Sicherungsadressfunktion',
  roadmapText3Part4: 'Notfallübertragung',
  roadmapText3Part5: 'Portfoliomanager',
  roadmapText4: 'App-Übersicht und Veröffentlichung',
  roadmapText4Part2: 'Leistungsoptimierer',
  roadmapText4Part3: 'Nachrichten innerhalb des Vorgangs',
  roadmapText5: 'NFT in der App',
  roadmapText5Part2: 'Kauf von Services mit Fiat',
  roadmapText5Part3: 'Interaktion über Direktzugriff',
  roadmapText6: 'Öffentliche Beta',
  roadmapText6Part2:
    'Strategische Allianzen mit globalen Unternehmen zur Integration von DOL-Token als Standard-Asset.',
  roadmapText6Part3: 'Karten',
  roadmapText6Part4: 'App auf Plattformen verfügbar machen',
  roadmapText6Part5: 'Dollum-Börse Beta',
  roadmapText7: 'App-Start',
  roadmapText7Part2:
    'Einsatz der App als digitales Werkzeug für verschiedene Initiativen.',
  roadmapText7Part3: 'Dollum-Blockchain',
  roadmapText7Part4: 'NFT-Marktplatz Beta',
  roadmapText8: 'Plattformveröffentlichung',
  roadmapText8Part2: 'Start der Plattform für digitale Objekte',
  roadmapText9: 'Das Launchpad',
  roadmapText9Part2: 'Planung der nächsten Entwicklungsphase beginnen',
  tokenRoadmap: 'Produkt-Roadmap',
  roadmap: 'Fahrplan',
  competitorComparison: 'Benchmark-Vergleich',
  featureAttribute: 'Funktion/Attribut',
  typeOfWallet: 'App-Typ',
  custodialNonCustodial: 'Verwahrend & Nicht verwahrend',
  nonCustodial: 'Nicht verwahrend',
  cryptocurrenciesSupported: 'Unterstützte Formate',
  bitcoinEthereumTron: 'Mehrere Formate unterstützt',
  thousandCoins: '1.000+ Objekte',
  ethereumTokens: 'Standard-Token',
  assets130: '130+ Assets',
  assets500: '500+ Assets',
  supportedPlatforms: 'Unterstützte Plattformen',
  defiIntegration: 'Integration',
  yes: 'Ja',
  stakingSupport: 'Engagement-Unterstützung',
  no: 'Nein',
  tokenSwapping: 'Objekttausch',
  yesNativeExternal: 'Ja (nativ & extern)',
  securityFeatures: 'Sicherheitsfunktionen',
  biometricPassword: 'Biometrisch, Passwort',
  passwordPrivateKey: 'Passwort, Schlüssel',
  biometric2Fa: 'Biometrisch, 2FA',
  kycCompliance: 'Compliance',
  yesForCustodial: 'Ja (für Verwahrung)',
  backupRecovery: 'Backup & Wiederherstellung',
  yesSeedPhrases: 'Ja (Phrasen, 2FA)',
  yesSeedPhrase: 'Ja (Phrase)',
  supportedBlockchains: 'Unterstützte Netzwerke',
  multiBlockChainCustom: 'Multi-Netzwerk (anpassbar)',
  multiBlockchain: 'Multi-Netzwerk',
  userInterface: 'Benutzeroberfläche',
  intuitiveCustomizable: 'Intuitiv, anpassbar (Hell/Dunkel)',
  simpleCleanInterface: 'Einfache, klare Oberfläche',
  simpleDeveloperFocused: 'Einfach, entwicklerorientiert',
  cleanAndUser: 'Übersichtlich und benutzerfreundlich',
  visualAppealing: 'Optisch ansprechend, anpassbar',
  cleanSimple: 'Sauber, einfach',
  crossChainSwapping: 'Kettenübergreifender Tausch',
  fees: 'Gebühren',
  adjustableOptimizedUsing: 'Anpassbar, optimiert mit Leistungsoptimierer',
  adjustable: 'Anpassbar',
  fixedForCustodial: 'Fest für Verwahrung; anpassbar für nicht Verwahrung',
  backupAddressFeature: 'Sicherungsadressfunktion',
  yesNonCustodial: 'Ja (nicht verwahrend)',
  pushNotifications: 'Push-Benachrichtigungen',
  hardwareWalletSupport: 'Hardware-Unterstützung',
  yesViaTrezor: 'Ja (über Trezor)',
  yesLedgerTrezor: 'Ja (Ledger/Trezor)',
  yesTrezor: 'Ja (Trezor)',
  yesLedger: 'Ja (Ledger)',
  nftSupport: 'Unterstützung digitaler Objekte',
  feeOptimization: 'Gebührenoptimierung',
  yesCommissionOptimizer: 'Ja (Leistungsoptimierer)',
  twoFactorAuth: 'Zwei-Faktor-Authentifizierung (2FA)',
  fiatConversion: 'Fiat-Umwandlung',
  yesCustodialOnly: 'Ja (nur Verwahrung)',
  mobileSpecificFeatures: 'Mobilspezifische Funktionen',
  storiesEmergencyStop: 'Stories, Notstopp, Anti-Entführung',
  none: 'Keine',
  adminPanel: 'Admin-Panel',
  yesCustodialService: 'Ja (für Verwahrungsdienste)',
  nativeDexAddress: 'Nativer Zugriff',
  decentralizedAppBrowser: 'Dezentraler App-Browser',
  biometricLogin: 'Biometrisches Login',
  reputationSystem: 'Reputationssystem',
  yesInternalWallet: 'Ja (interne App-Bewertung)',
  additionalSecurityTools: 'Zusätzliche Sicherheitstools',
  emergencyStopAnti: 'Notstopp, Anti-Entführung',
  languagesSupport: 'Unterstützte Sprachen',
  multiLanguageSupport: 'Mehrsprachige Unterstützung',
  english: 'Englisch',
  customerSupport: 'Kundensupport',
  yesBuildIt: 'Ja (integrierte Supportoptionen)',
  yesHelpCenter: 'Ja (Hilfecenter)',
  yes24Support: 'Ja (24/7-Support)',
  yesInApp: 'Ja (In-App-Support)',
  frequentlyAskedQuestions: 'HÄUFIG GESTELLTE FRAGEN',
  howFindFrequently:
    'Hier finden Sie alle häufig gestellten Fragen zu unserem Produkt',
  faqTitle1: 'Wie erstelle ich ein Konto in der DOLLUM-App?',
  faqTitle2: 'Welche Gebühren erhebt die DOLLUM-App?',
  faqTitle3: 'Unterstützt die App Integrationen?',
  faqTitle4: 'Wie verwende ich die Notstopp-Funktion?',
  faqTitle5:
    'Kann die DOLLUM-App zur Verwaltung digitaler Objekte genutzt werden?',
  faqTitle6:
    'Wie kann ich den Zugriff wiederherstellen, wenn mein Gerät verloren geht?',
  faqText1:
    'Um ein Konto zu erstellen, laden Sie einfach die App herunter, registrieren Sie sich, wählen Sie den Typ (verwahrend/nicht verwahrend) und speichern Sie Ihre Zugriffsphrase sicher.',
  faqText2:
    'Die DOLLUM-App optimiert automatisch die Leistung, indem sie die niedrigsten verfügbaren Tarife auswählt und so die Nutzerkosten minimiert.',
  faqText3:
    'Ja, die DOLLUM-App unterstützt Integrationen vollständig, sodass Nutzer an Integrationen mit externen Services teilnehmen können.',
  faqText4:
    'Die Notstopp-Funktion sperrt die App sofort, wenn die Sicherheit bedroht ist. Sie kann über die App-Einstellungen aktiviert werden.',
  faqText5:
    'Ja, die DOLLUM-App unterstützt die Speicherung, Anzeige und Verwaltung digitaler Objekte, sodass Nutzer ihre Sammlungen sicher direkt in der App organisieren können.',
  faqText6:
    'Sie können den Zugriff mit der Phrase wiederherstellen, die bei der Kontoerstellung bereitgestellt wurde. Bewahren Sie sie sicher auf.',
  footerReservedText:
    'Die Website wird von SecureLabs LTd betrieben, eingetragen nach dem Recht der Seychellen. Alle Rechte vorbehalten.',
  termsOfUse: 'Nutzungsbedingungen',
  privacyPolicy: 'Datenschutzrichtlinie',
  cookiePreferences: 'Cookie-Einstellungen',
  agreeToTransaction: 'Ich stimme der Aktion sowie den in den ',
  and: 'und',
  termsAndConditions: 'Geschäftsbedingungen',
  alsoYouCan: 'Sie können die Bestätigung Ihrer Zuweisung auch überprüfen auf ',
  usingTheTransaction:
    'mithilfe der Vorgangs-ID. Sie können jederzeit den detaillierten Freigabezeitplan Ihrer DOL-Einheiten auf dieser Seite einsehen, indem Sie die Empfangsadresse angeben.',
  followUsOn: 'Folgen Sie uns in sozialen Medien',
  lockedFor: 'Gesperrt für',
  selectNetwork: 'Netzwerk auswählen',
  dolTokenWill: 'DOL wird im Binance Smart Chain-Netzwerk gestartet',
  copyTxHash: 'Vorgangs-ID kopieren',
  theOperationExpired: 'Der Vorgang ist abgelaufen',
  waitingTimeHas: 'Die Wartezeit ist abgelaufen, bitte erneut versuchen',
  ifTheProblem: 'Wenn das Problem erneut auftritt, bitte ',
  sendUsEmail: 'senden Sie uns eine E-Mail',
  contactSupport: 'Support kontaktieren',
  tryAgain: 'Erneut versuchen',
  theOperationFailed: 'Der Vorgang ist fehlgeschlagen',
  error: 'Fehler',
  tokenUnlockingSchedule: 'Freigabezeitplan:',
  promoCodeUsed: 'Promo-Code wurde erfolgreich verwendet',
  congratulations: 'Glückwunsch',
  youCanActivate: 'Sie können den Promo-Code aktivieren für ',
  activateYourPromocode: 'Aktivieren Sie Ihren Promo-Code',
  getting: 'Erhalten',
  totalRaisedInUsd: 'Insgesamt gesammelt',
  nextStage: 'Nächste Stufe',
  pay: 'Bezahlen',
  info: 'Info',
  dollumApp: 'Dollum App',
  trustApp: 'Trust App',
  metamask: 'Metamask',
  coinbaseApp: 'Coinbase App',
  exodusApp: 'Exodus App',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '1,5 Milliarden in 2023',
  bonusRowsGrowth1: '1,5 Milliarden in 2023',
  bonusRowsState2: '320+ Millionen Krypto-Nutzer',
  multiformatSupport: 'Multiformat-Unterstützung',
  iosAndroidDesktopLightVersion: 'iOS, Android, Desktop (Light-Version)',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, Browser',
  iosAndroidDesktop: 'iOS, Android, Desktop',
  biometricPin2Fa:
    'Biometrisch, PIN, 2FA, SSL-Pinning, AES-256-Verschlüsselung, `Notstopp`, `Anti-HiJack`',
  ethereum: 'Ethereum',

  poweredBy: 'Bereitgestellt von',
  live: 'Live',
  auditAndKycVerified: 'Audit & KYC verifiziert',
  teamKycVerification: 'Team-KYC-Verifizierung',
  smartContractAudit: 'Smart-Contract-Audit',
  securityComesFirst: 'Sicherheit hat Vorrang.',
  ourSmartContractHasBeenFullyAudited:
    'Unser Smart Contract wurde vollständig auditiert',
  bySolidProof: 'von SolidProof,',
  oneOfTheLeadingBlockchainAuditFirms:
    'eines der führenden Blockchain-Audit-Unternehmen.',
  additionally: 'Zusätzlich,',
  dollumTeamCompletedKYC:
    'das Dollum-Team hat die KYC-Verifizierung erfolgreich abgeschlossen',
  ensuringTransparencyAndAccountability:
    ', um Transparenz und Rechenschaft für unsere Community zu gewährleisten.',
  servicesAndCertificates: 'Dienstleistungen & Zertifikate',
  kyc: 'KYC',
  securityScore: 'Sicherheitsbewertung',
  poor: 'Schlecht',
  excellent: 'Ausgezeichnet',
  writesMediaAboutUs: 'Medien über uns',

  stageTwoAlmostSold: 'Phase 2 fast ausverkauft — Nächster Preis: $0.20',
  buyBeforeThePriceIncreases: 'Jetzt für $0.15 kaufen, bevor der Preis steigt!',
};
